<template>
  <div class="page-wrapper mt-3" style="width: 100%">
    <PageTitle title="Личный кабинет студента: Эссе команды" />
    <!-- ШАГ 1: ВЫБОР АКТИВНОГО КУРСА -->


    <!-- ТАБЛИЦА РЕЗУЛЬТАТОВ -->
        <div class="page-wrapper mt-2 w-100">
          <v-row class="ma-1 mt-4">
            <!-- КОЛОНКА 1: ЧЕРНОВИКИ (DRAFT) -->
            <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
              <v-card variant="flat" color="grey-lighten-4" class="pa-3 rounded-lg h-100">
                <div class="d-flex align-center justify-space-between mb-3">
                  <span class="text-subtitle-1 font-weight-bold text-grey-darken-3">📝 Черновики</span>
                  <v-badge color="grey" :content="getColCount('DRAFT')" inline class="font-weight-bold"></v-badge>
                </div>
                <v-divider class="mb-3"></v-divider>

                <div class="kanban-scroll-zone">
                  <v-card v-for="item in getColItems('DRAFT')" :key="item.esseId" class="mb-2 pa-3 rounded-lg border bg-white" variant="flat">
                    <div class="font-weight-bold text-body-2">{{ item.studentFullName }}</div>
                    <div class="text-caption text-grey mt-1">Модуль: {{ item.moduleName }}</div>
                    <div class="text-caption text-grey-lighten-1 mt-1">{{ formatDateTime(item.createdAt) }}</div>
                    <div class="mt-3 pt-2 border-top-light">
                      <div class="d-flex align-center justify-space-between w-100">
                        <!-- Левая часть:  маркер статуса -->
                        <div class="flex-grow-1 mr-2 text-truncate">
                        </div>
                        <!-- Правая часть: Блок иконок -->
                        <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                          <v-btn
                           icon="mdi-file-document-outline"
                           size="x-small"
                           variant="tonal"
                           color="deep-orange-darken-1"
                           density="comfortable"
                           class="rounded-md ma-1"
                           style="min-width: 28px; width: 28px; height: 28px;"
                           title="Скачать"
                            @click="downloadDocument(item)"
                          ></v-btn>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <div v-if="getColCount('DRAFT') === 0" class="text-center text-caption text-grey py-4 font-italic">Пусто</div>
                </div>

              </v-card>
            </v-col>
            <!-- КОЛОНКА 2: В ОЧЕРЕДИ (SENT) -->
            <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
              <v-card variant="flat" color="amber-lighten-5" class="pa-3 rounded-lg h-100">
                <div class="d-flex align-center justify-space-between mb-3">
                  <span class="text-subtitle-1 font-weight-bold text-amber-darken-4">⏳ В очереди</span>
                  <v-badge color="amber-darken-3" :content="getColCount('SENT')" inline class="font-weight-bold"></v-badge>
                </div>
                <v-divider class="mb-3"></v-divider>

                <div class="kanban-scroll-zone">
                  <v-card v-for="item in getColItems('SENT')" :key="item.esseId" class="mb-2 pa-3 rounded-lg border bg-white border-left-amber" variant="flat">
                    <div class="font-weight-bold text-body-2">{{ item.studentFullName }}</div>
                    <div class="text-caption text-grey mt-1">Модуль: {{ item.moduleName }}</div>
                    <v-chip size="x-small" color="warning" class="mt-2 font-weight-bold" variant="flat">Ожидает проверки</v-chip>
                  </v-card>
                  <div v-if="getColCount('SENT') === 0" class="text-center text-caption text-grey py-4 font-italic">Пусто</div>
                </div>
              </v-card>
            </v-col>
            <!-- КОЛОНКА 3: В РАБОТЕ ИИ (IN_WORK) -->
            <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
              <v-card variant="flat" color="blue-lighten-5" class="pa-3 rounded-lg h-100">
                <div class="d-flex align-center justify-space-between mb-3">
                  <span class="text-subtitle-1 font-weight-bold text-blue-darken-3">🤖 В работе ИИ</span>
                  <v-badge color="blue" :content="getColCount('IN_WORK')" inline class="font-weight-bold"></v-badge>
                </div>
                <v-divider class="mb-3"></v-divider>

                <div class="kanban-scroll-zone">
                  <v-card v-for="item in getColItems('IN_WORK')" :key="item.esseId" class="mb-2 pa-3 rounded-lg border bg-white border-left-blue" variant="flat">
                    <div class="font-weight-bold text-body-2">{{ item.studentFullName }}</div>
                    <div class="text-caption text-grey mt-1">Модуль: {{ item.moduleName }}</div>
                    <div class="d-flex align-center text-caption text-deep-orange-darken-1 font-weight-bold mt-2">
                      <v-progress-circular indeterminate size="16" width="2" class="mr-2"></v-progress-circular>
                      Проверяется...
                    </div>
                    <div class="mt-3 pt-2 border-top-light">
                      <div class="d-flex align-center justify-space-between w-100">
                        <!-- Левая часть:  маркер статуса -->
                        <div class="flex-grow-1 mr-2 text-truncate">
                        </div>
                        <!-- Правая часть: Блок иконок -->
                        <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                          <v-btn
                            icon="mdi-file-document-outline"
                            size="x-small"
                            variant="tonal"
                            color="deep-orange-darken-1"
                            density="comfortable"
                            class="rounded-md ma-1"
                            style="min-width: 28px; width: 28px; height: 28px;"
                            title="Скачать"
                            @click="downloadDocument(item)"
                          ></v-btn>


                        </div>
                      </div>
                    </div>
                  </v-card>
                  <div v-if="getColCount('IN_WORK') === 0" class="text-center text-caption text-grey py-4 font-italic">Пусто</div>
                </div>
              </v-card>
            </v-col>
             <!-- КОЛОНКА 4: ПРОВЕРЕНО ИИ (CHECKED / FAIL_CHECK / SYSTEM_ERROR) -->
                    <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
                      <v-card variant="flat" color="green-lighten-5" class="pa-3 rounded-lg h-100 d-flex flex-column">
                        <!-- Шапка колонки -->
                        <div class="d-flex align-center justify-space-between mb-3">
                          <span class="text-subtitle-1 font-weight-bold text-green-darken-3">✅ Проверено</span>
                          <v-badge color="green" :content="getColCount('CHECKED')" inline class="font-weight-bold"></v-badge>
                        </div>
                        <v-divider class="mb-3"></v-divider>
                        <!-- Скролл-зона с карточками студентов -->
                        <div class="kanban-scroll-zone flex-grow-1">
                          <v-card
                            v-for="item in getColItems('CHECKED')"
                            :key="item.esseId"
                            class="mb-2 pa-3 rounded-lg border bg-white d-flex flex-column justify-space-between"
                            :class="item.status === 'FAIL_CHECK' || item.status === 'SYSTEM_ERROR' ? 'border-left-red' : 'border-left-green'"
                            variant="flat"
                            style="min-height: 140px;"
                          >

                            <!-- Верхняя часть карточки: ФИО и Оценка -->
                            <div>
                              <div class="d-flex justify-space-between align-start w-100 mb-1">
                                <!-- ФИО студента (переносится по словам, если не влезает) -->
                                <div class="font-weight-bold text-body-2 pr-2 text-wrap" style="word-break: break-word; line-height: 1.3;">
                                  {{ item.studentFullName }}
                                </div>
                                <!-- Вывод итоговой оценки или плашки сбоя -->
                                <v-chip
                                  v-if="item.status === 'CHECKED'"
                                  size="x-small"
                                  color="success"
                                  variant="flat"
                                  class="font-weight-bold px-2 py-2"
                                >
                                  {{ item.totalGrade }}
                                </v-chip>
                                <v-chip
                                  v-else
                                  size="x-small"
                                  color="error"
                                  variant="flat"
                                  class="font-weight-bold px-2 py-2"
                                >
                                  Сбой
                                </v-chip>
                              </div>
                              <!-- Название модуля -->
                              <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                                Id: {{ item.esseId }}
                              </div>
                              <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                                Модуль: {{ item.moduleName }}
                              </div>
                              <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                                Предмет: {{ item.subjectName }}
                              </div>
                              <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                                Проба: {{ item.probeName }}
                              </div>
                              <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                                Попытка: {{ item.attempt }}
                              </div>
                                <v-chip size ="small" class="mr-2 mt-2"  color="red" v-if="item.solvedAsAssignment"> <v-icon icon="mdi-label" start></v-icon>Решено как задание</v-chip>
                                <v-chip size ="small" class="mr-2 mt-2"   color="red" v-if="item.conceptReplacedByFormat"> <v-icon icon="mdi-label" start></v-icon>Подмена понятий</v-chip>
                                <v-chip size ="small" class="mr-2 mt-2"   color="red" v-if="item.signsOfNonIndependentText"> <v-icon icon="mdi-label" start></v-icon>Не самостоятельная работа</v-chip>
                                <v-chip size ="small" class="mr-2 mt-2"  color="red" v-if="item.workNotSubmitted"> <v-icon icon="mdi-label" start></v-icon>Работа не представлена</v-chip>
                                <v-chip size ="small" class="mr-2 mt-2"   color="red" v-if="item.productDoesNotFitIntoModularTask"> <v-icon icon="mdi-label" start></v-icon>Не входит в мод. задачу</v-chip>
                            </div>
                            <!-- Нижняя часть карточки -->
                            <div class="mt-3 pt-2 border-top-light">
                              <div class="d-flex align-center justify-space-between w-100">
                                <!-- Левая часть:  маркер статуса -->
                                <div class="flex-grow-1 mr-2 text-truncate">
                                  <span v-if="item.status === 'CHECKED'" class="text-caption text-success font-weight-medium">
                                    <v-icon size="x-small" color="success" start>mdi-check-circle-outline</v-icon> Проверено
                                  </span>
                                  <span v-else class="text-caption text-error font-weight-medium">
                                    <v-icon size="x-small" color="error" start>mdi-alert-circle-outline</v-icon> Сбой
                                  </span>
                                </div>
                                <!-- Правая часть: Блок иконок -->
                                <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                                  <v-btn
                                   icon="mdi-file-document-outline"
                                   size="x-small"
                                   variant="tonal"
                                   color="deep-orange-darken-1"
                                   density="comfortable"
                                   class="rounded-md ma-1"
                                   style="min-width: 28px; width: 28px; height: 28px;"
                                   title="Скачать"
                                    @click="downloadDocument(item)"
                                  ></v-btn>
                                  <v-btn
                                    v-if="item.status === 'CHECKED'"
                                    icon="mdi-eye-outline"
                                    size="x-small"
                                    variant="tonal"
                                    color="deep-orange-darken-1"
                                    density="comfortable"
                                    class="rounded-md ma-1"
                                    style="min-width: 28px; width: 28px; height: 28px;"
                                    title="Посмотреть рецензию ИИ"
                                    @click="viewEssayDetails(item.esseId)"
                                  ></v-btn>


                                </div>
                              </div>
                            </div>
                          </v-card>
                          <!-- Заглушка, если колонка пуста -->
                          <div v-if="getColCount('CHECKED') === 0" class="text-center text-caption text-grey py-8 font-italic">
                            Нет проверенных работ
                          </div>
                        </div>
                      </v-card>
                    </v-col>
          </v-row>
        </div>

    <!-- карта рецензирования эссе -->
        <v-dialog v-model="detailsDialog" fullscreen transition="dialog-bottom-transition">
           <v-card v-if="selectedEssay" class="bg-grey-lighten-4 font-sans">
             <!-- Шапка окна с полным ФИО и итоговым баллом -->
             <v-toolbar color="indigo-darken-4" dark elevation="2">
               <v-btn icon="mdi-close" variant="text" @click="detailsDialog = false"></v-btn>
               <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-bold">
                 <v-icon start class="mr-2">mdi-file-certificate-outline</v-icon>
                 Рецензия: {{ selectedEssay.studentFullName }}  (попытка: {{ selectedEssay.attempt }})
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
             <div class="pa-3 pa-md-6" style="overflow-y: auto; height: calc(100vh - 64px);">
               <v-row class="ma-0">
                 <!-- ЛЕВАЯ КАРТА: Текст эссе  -->
                 <v-col cols="12" md="6" class="pa-2">
                   <v-card variant="flat" class="pa-4 pa-md-6 bg-white rounded-xl shadow-soft h-100">
                     <v-card-title class="px-0 pt-0 text-h6 font-weight-bold text-indigo-darken-4 d-flex align-center">
                       <v-icon color="indigo" class="mr-2">mdi-text-account</v-icon>Текст эссе
                     </v-card-title>
                     <v-card-subtitle class="px-0 mb-4 text-caption text-grey-darken-1">
                       Модуль: {{ selectedEssay.moduleName }} | Сдано: {{ formatDateTime(selectedEssay.createdAt) }}
                     </v-card-subtitle>
                     <v-divider class="mb-5"></v-divider>
                     <div style="white-space: pre-wrap; line-height: 1.7;" class="text-body-1 text-grey-darken-4 text-justify pr-2">
                       {{ selectedEssay.essayBody }}
                     </div>
                   </v-card>
                 </v-col>
                 <!-- ПРАВАЯ КАРТА: Разбор критериев  -->
                 <v-col cols="12" md="6" class="pa-2">
                   <v-card variant="flat" class="pa-4 pa-md-6 bg-white rounded-xl shadow-soft h-100 d-flex flex-column">
                     <!-- Заголовок и итоговый балл -->
                     <div class="d-flex justify-space-between align-center mb-4">
                       <div class="d-flex align-center">
                         <v-avatar color="indigo-lighten-5" class="mr-3" size="default">
                           <v-icon color="indigo">mdi-robot-outline</v-icon>
                         </v-avatar>
                         <div>
                           <span class="text-h6 font-weight-bold d-block text-indigo-darken-4" style="line-height: 1.2;">Аналитика ИИ</span>
                           <span class="text-caption text-grey">Автоматическая портфельная оценка</span>
                         </div>
                       </div>
                       <v-card variant="flat" color="indigo-lighten-5" class="pa-2 px-4 rounded-lg text-center">
                         <span class="text-caption text-indigo-darken-2 font-weight-medium d-block uppercase tracking-wider" style="font-size: 0.65rem !important;">Итоговый балл</span>
                         <span class="text-h4 font-weight-black text-indigo">{{ selectedEssay.totalGrade }} б.</span>
                       </v-card>
                     </div>
                     <v-divider class="mb-5"></v-divider>
                     <!-- СПИСОК АТОМАРНЫХ ПОКАЗАТЕЛЕЙ ИЗ МАТРИЦЫ -->
                     <div class="flex-grow-1">
                       <v-card
                         v-for="criterion in selectedEssay.criteriaResults"
                         :key="criterion.id"
                         variant="flat"
                         class="mb-4 rounded-xl border bg-grey-lighten-5 overflow-hidden"
                       >
                         <!-- Шапка показателя с оценкой -->
                         <div class="d-flex justify-space-between align-center px-4 py-3 bg-white border-bottom-light">
                           <span class="font-weight-black text-subtitle-1 text-indigo-darken-3">
                             <v-icon size="small" color="indigo" class="mr-1">mdi-bookmark-check-outline</v-icon>
                             Показатель №{{ criterion.criteriaOrder }}
                           </span>
                           <v-chip
                             size="small"
                             :color="criterion.criteriaRate > 1 ? 'success' : (criterion.criteriaRate == 1 ? 'warning' : 'error')"
                             variant="flat"
                             class="font-weight-bold px-3"
                           >
                             Оценка: {{ criterion.criteriaRate }} / 3 б.
                           </v-chip>
                         </div>

                         <!-- Развернутый структурированный текст рецензии ИИ -->
                         <v-card-text class="pa-4 bg-grey-must-lighten-5">
                           <div style="white-space: pre-wrap; line-height: 1.6;" class="text-body-2 text-grey-darken-3 custom-review-text pl-1">
                             {{ criterion.criteriaRateDescription }}
                           </div>
                         </v-card-text>
                       </v-card>

                       <!-- Сообщение, если логи пустые -->
                       <v-alert
                         v-if="!selectedEssay.criteriaResults || selectedEssay.criteriaResults.length === 0"
                         type="warning"
                         variant="tonal"
                         class="rounded-xl mt-2 text-body-2"
                       >
                         Детальные критерии оценивания отсутствуют. Проверьте лог работы приложения.
                       </v-alert>

                        <v-card variant="flat" class="mb-4 rounded-xl border bg-grey-lighten-5 overflow-hidden">
                            <div class="d-flex justify-space-between align-center px-4 py-3 bg-white border-bottom-light">
                                <span class="font-weight-black text-subtitle-1 text-indigo-darken-3">
                                    <v-icon size="small" color="indigo" class="mr-1">mdi-bookmark-check-outline</v-icon>
                                    Экспертное резюме
                                </span>
                            </div>
                            <v-card-text class="pa-4 bg-grey-must-lighten-5">
                                <div v-if="selectedEssay.additionalComment  && selectedEssay.additionalComment.length >0" style="white-space: pre-wrap; line-height: 1.6;" class="text-body-2 text-grey-darken-3 custom-review-text pl-1">
                                    {{ selectedEssay.additionalComment }}
                                </div>
                                <v-alert
                                    v-else
                                    type="warning"
                                    variant="tonal"
                                    class="rounded-xl mt-2 text-body-2"
                                >
                                    Данные отсутствуют.
                                </v-alert>
                            </v-card-text>
                        </v-card>

                        <v-card variant="flat" class="mb-4 rounded-xl border bg-grey-lighten-5 overflow-hidden">
                            <div class="d-flex justify-space-between align-center px-4 py-3 bg-white border-bottom-light">
                                <span class="font-weight-black text-subtitle-1 text-indigo-darken-3">
                                    <v-icon size="small" color="indigo" class="mr-1">mdi-bookmark-check-outline</v-icon>
                                    Функциональная микрозадача
                                </span>
                            </div>
                            <v-card-text class="pa-4 bg-grey-must-lighten-5">
                                <div v-if="selectedEssay.functionalMicrotask  && selectedEssay.functionalMicrotask.length >0" style="white-space: pre-wrap; line-height: 1.6;" class="text-body-2 text-grey-darken-3 custom-review-text pl-1">
                                    {{ selectedEssay.functionalMicrotask }}
                                </div>
                                <v-alert
                                    v-else
                                    type="warning"
                                    variant="tonal"
                                    class="rounded-xl mt-2 text-body-2"
                                >
                                    Данные отсутствуют.
                                </v-alert>
                            </v-card-text>
                        </v-card>
                     </div>
                   </v-card>
                 </v-col>
               </v-row>
             </div>
           </v-card>
        </v-dialog>


        </div>
      </template>
<script setup>
import { ref, onMounted, watch } from "vue";
import PageTitle from "@/elements/PageTitle.vue";
import { customAxios } from "@/service/customAxios";
import { usePopupStore } from "@/store/popup";
import { formatDateTime } from "@/util/common";
// Переменная для хранения выбранной студентом попытки из истории
const selectedAttempt = ref(null);

const { showError } = usePopupStore();



// Переменные состояния для выбранной пробы и её контекста

const submissionBody = ref("");

// Состояние модального окна рецензии ИИ


const results = ref([]);
const showLoader = ref(false);
const CURRENT_MODE = ref('IDLE');
let refreshInterval = null;
const detailsDialog = ref(false);
const selectedEssay = ref(null);

function setupSmartRefresh(isAiActive) {
  // Вычисляем целевой режим и задержку
  const targetMode = isAiActive ? 'ACTIVE' : 'PASSIVE';
  const delay = isAiActive ? 15000 : 60000;



  // Если режим не изменился — ничего не трогаем, пусть текущий интервал тикает
  if (CURRENT_MODE.value === targetMode && refreshInterval) return;

  // Если режим изменился (или это первый запуск) — перезапускаем интервал
  if (refreshInterval) clearInterval(refreshInterval);

  CURRENT_MODE.value = targetMode;
  console.log(`📡 Канбан перешел в режим: [${targetMode}]. Интервал опроса: ${delay / 1000} сек.`);

  refreshInterval = setInterval(async () => {
    await fetchDashboardData();
  }, delay);
}

/**
 * 1. Загрузка списка доступных курсов
 */


async function downloadDocument(esse){
  try {
    const response = await customAxios.get('/v1/team/results/download/doc/' + esse.esseId, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;

    let fileName = esse.studentFullName + '_' + esse.subjectName + '_' + esse.probeName + '.docx';
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();

    // Очищаем память и удаляем элемент
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

  } catch (error) {
    console.error('Ошибка при скачивании файла:', error);

  }
}

 async function fetchDashboardData() {
     if (results.value.length === 0) showLoader.value = true;

     try {


       const resData = await customAxios.get('/v1/team/results');

       if (resData.status === 200) results.value = resData.data || [];

       // Проверяем, есть ли на доске процессы проверки ИИ прямо сейчас
       const hasActiveAiProcess = results.value.some(r => r.status === 'SENT' || r.status === 'IN_WORK');

       // Передаем флаг в умный диспетчер режимов
       setupSmartRefresh(hasActiveAiProcess);

     } catch (e) {
       showError(e);
       results.value = [];
     } finally {
       showLoader.value = false;
     }
   }

/**
 * 3. Выбор конкретной пробы в дереве навигации
 */

 function getColItems(columnStatus) {
   if (!results.value) return [];

   if (columnStatus === 'CHECKED') {
     return results.value.filter(item =>
     item.status === 'CHECKED' ||
     item.status === 'FAIL_CHECK' ||
     item.status === 'SYSTEM_ERROR' ||
     item.status === 'SYSTEM_ERROR_NETWORK' ||
     item.status === 'SYSTEM_ERROR_NO_CRITERIES' ||
     item.status === 'SYSTEM_ERROR_CRITERIES_COUNT_MISMATCH' ||
     item.status === 'PROMPT_INJECTION_DETECTED'
     );
   }

   return results.value.filter(item => item.status === columnStatus);
 }

function getColCount(columnStatus) {
  return getColItems(columnStatus).length;
}




/**
 * 6. Запрос рецензии ИИ по ID пробы с мягким парсингом структуры
 */
    async function viewEssayDetails(esseId) {
      try {
        const r = await customAxios.get(`/v1/team/results/essay/${esseId}`);
        if (r.status === 200) {
          selectedEssay.value = r.data;
          detailsDialog.value = true;
        }
      } catch (e) {
        showError(e);
      }
    }




watch(selectedAttempt, (newAttempt) => {
  if (newAttempt) {
    // Перезаписываем submissionBody текстом выбранной из истории попытки
    submissionBody.value = newAttempt.body || "";
  }
});

onMounted(async () => {
  await fetchDashboardData();
});
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}
.line-height-relaxed {
  line-height: 1.6;
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.border-bottom:last-child {
  border-bottom: none;
}
.border-left {
  border-left: 3px solid #1867c0;
}

/* Вращение иконки загрузки во время проверки нейросетью */
.v-chip--loading :deep(.v-icon) {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.border-left-strong {
  border-left: 4px solid #1976D2 !important;
}
</style>


